import { currencyMask } from '@utils/masks/currencyMask'
import { PreviewCard } from '../PreviewCard'
import { ChartPieSliceIcon } from '@assets/svgs/ChartPieSliceIcon'
import { BowISteamIcon } from '@assets/svgs/BowISteamIcon'
import { SprayBottleIcon } from '@assets/svgs/SprayBottleIcon'
import { PackageCardIcon } from '@assets/svgs/PackageCardIcon'
import { emotionTheme } from '@styles/theme'

export const budgetPreviews = () => {
  const inventoryTotal = 287000
  const countedItems = 100
  const foodTotal = {
    percentageValue: 50.02,
    value: 143500
  }
  const nonFoodTotal = {
    percentageValue: 50.98,
    value: 143500
  }

  return [
    <PreviewCard
      label="Total do Inventário"
      percentageValue={currencyMask(inventoryTotal.toFixed(2))}
      rightIcon={{
        icon: <ChartPieSliceIcon />,
        color: emotionTheme.colors.success.color,
        background: emotionTheme.colors.success.background
      }}
    />,
    <PreviewCard
      label="Total Alimentar"
      percentageValue={`${foodTotal.percentageValue.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(foodTotal.value.toFixed(2))}
      rightIcon={{
        icon: <BowISteamIcon />,
        color: emotionTheme.colors.primary,
        background: emotionTheme.colors.gray.light
      }}
      textColor={emotionTheme.colors.primary}
    />,
    <PreviewCard
      label="Total Não Alimentar"
      percentageValue={`${nonFoodTotal.percentageValue.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(nonFoodTotal.value.toFixed(2))}
      rightIcon={{
        icon: <SprayBottleIcon />,
        color: emotionTheme.colors.purple.color,
        background: emotionTheme.colors.purple.background
      }}
      textColor={emotionTheme.colors.purple.color}
    />,
    <PreviewCard
      label="Itens Contados"
      percentageValue={countedItems}
      rightIcon={{
        icon: <PackageCardIcon />,
        color: emotionTheme.colors.orange.color,
        background: emotionTheme.colors.orange.background
      }}
    />
  ]
}
